// Signature → job-status mapping for Ferrari paper HAWB re-uploads.
//
// When a signed copy of an already-created Ferrari job is uploaded, the
// parser reports which signature blocks have writing
// (extracted.signaturesPresent). This maps those raw signals onto the
// EXISTING job status vocabulary — no parallel status words:
//
//   delivery confirmation signed → "complete"    (the run happened; job
//                                                 surfaces on Ready to bill)
//   shipper signed only          → "inProgress"  (package picked up /
//                                                 in transit)
//   neither signed               → no change
//
// ADVANCE-ONLY: a signature can only move status forward, never backward
// (re-uploading an unsigned copy of a complete job must not reopen it),
// and cancelled jobs are never touched. Direction is deliberately not
// part of this — re-uploads must never re-flip inbound/outbound.

const STATUS_RANK = {
  intake: 0,
  pool: 1,
  grabbed: 2,
  confirmed: 3,
  inProgress: 4,
  complete: 5,
};

/**
 * @param {string} currentStatus - the job's current status
 * @param {Object} sigs - { shipperSigned, deliveryConfirmationSigned }
 *   (the bulk-POD cards store the latter as `deliverySigned` — both keys
 *   are accepted)
 * @returns {string|null} the status to advance to, or null for no change
 */
export function statusAdvanceFromSignatures(currentStatus, sigs) {
  if (!sigs || currentStatus === "cancelled") return null;
  const deliverySigned = !!(sigs.deliveryConfirmationSigned ?? sigs.deliverySigned);
  const target = deliverySigned ? "complete" : sigs.shipperSigned ? "inProgress" : null;
  if (!target) return null;
  const cur = STATUS_RANK[currentStatus];
  if (cur != null && cur >= STATUS_RANK[target]) return null;
  return target;
}
